export const getFifthFlowId = state => state.fifthFlows.fifthFlow.id;
export const getFifthFlowData = state => state.fifthFlows.fifthFlow;
export const fifthFlowIsFetching = state => state.fifthFlows.loading;